// Prepared lesson examples. These never call a model or create a conversation.
export const LEARN_DEMOS = {
  invitation: {
    label: 'Write an invitation',
    title: 'From a rough idea to a useful email.',
    prompt: 'Write a friendly email inviting neighbors to a park cleanup on Saturday, 9–11am. Meet at the park entrance and bring gloves. Keep it under 80 words. Ask people to reply if they can come.',
    response: 'Subject: Join our park cleanup\n\nHi neighbors,\n\nJoin us this Saturday from 9–11am for a park cleanup. We’ll meet at the park entrance. Please bring gloves. Everyone is welcome!\n\nReply if you can make it. We’d love to see you there.',
    followUp: 'Make it a short group text instead. Keep the time, meeting point, gloves, and request to reply.',
    revised: 'Park cleanup this Saturday, 9–11am! Meet at the park entrance and bring gloves. Everyone’s welcome. Reply if you can join us.',
    captions: [
      'The prompt gives the task, the details, and the format. Each becomes something you can check in the answer.',
      'Read the whole draft. Check Saturday, 9–11am, the park entrance, gloves, and the request to reply.',
      'Ask for a specific change. Tell AI which facts must stay the same.',
      'The format changed; the facts stayed. This is the version you can copy after checking it.',
    ],
  },
  venues: {
    label: 'Compare options',
    title: 'Turn a comparison into a decision.',
    prompt: 'Compare venues for 40 guests. A holds 45, costs $100, and has step-free access. B holds 60 and costs $150; access is unknown. Use only these notes. We need step-free access.',
    response: 'Venue A fits 40 guests, costs $100, and has confirmed step-free access.\n\nVenue B has room for 60 and costs $150. Its access is unknown.\n\nA meets the stated needs for less. Confirm availability and final terms before booking.',
    followUp: 'Turn that into three questions I can send to Venue A before booking. Do not assume availability or that the quoted price includes every fee.',
    revised: '1. Are you available for our event date and time?\n2. What is the total cost, including any fees or deposit?\n3. Can you confirm step-free access to the event room and the facilities our guests will use?',
    captions: [
      'Supply the evidence and the decision criteria together. Keep missing information visible.',
      'The answer distinguishes known facts from unknowns. Extra capacity alone does not make B the better fit.',
      'Turn the recommendation into a practical next step: questions for the venue.',
      'These questions help you verify the decision outside the AI conversation.',
    ],
  },
  meeting: {
    label: 'Use meeting notes',
    title: 'From meeting notes to clear next steps.',
    attachment: 'meeting-notes.txt',
    source: 'Maya will send the draft Friday. We discussed translating the flyer; no owner or date was agreed.',
    prompt: 'Extract actions from these meeting notes. Separate confirmed tasks from proposals. Do not invent owners or deadlines.',
    response: 'Confirmed task\nMaya will send the draft Friday.\n\nProposal\nTranslate the flyer. Owner: not specified. Deadline: not specified.',
    followUp: 'Write a short follow-up for the team. Confirm Maya’s task and ask whether we should proceed with translation before assigning anyone.',
    revised: 'Maya will send the draft Friday. We also discussed translating the flyer, but have not agreed to proceed or assigned an owner or deadline. Should we move forward with translation?',
    captions: [
      'Attach the source and ask for a specific result. Here, the lesson includes the complete sample file.',
      'An idea discussed in a meeting is not automatically an assigned task. Check the summary against the notes.',
      'Ask for a useful follow-up that preserves the difference between a task and a proposal.',
      'The team gets a clear update without invented commitments or deadlines.',
    ],
  },
};

export const LESSON_DEMOS = {
  'first-prompt': 'invitation',
  'being-specific': 'invitation',
  'providing-context': 'invitation',
  'iterating-prompts': 'invitation',
  'common-mistakes': 'venues',
  'writing-assistant': 'invitation',
  research: 'venues',
  'file-uploads': 'meeting',
};
